import { useEffect, useState } from "react"
import Form from "../../../../Components/Form"
import Workspace from "../../../../APIController/Workspace"
import Text from "../../../../Components/Text"
import TextInput from "../../../../Components/Form/TextInput"
import Button from "../../../../Components/Buttons/Button"
import { useNavigate } from "react-router-dom";
import SumUpPayment from "../../../../Components/SumUpPayment"
import Checkbox from "../../../../Components/Form/Checkbox"
import { GoogleMapsLocation } from "../../../../Components/GoogleMapsLocation"
import NumberInput from "../../../../Components/Form/NumberInput"
import User from "../../../../APIController/User"
import Dropdown from "../../../../Components/Dropdown"
import { FileUploader } from "../../../../Components/Form/FileUploader"
import { getWorkspace } from "../../../../Model/Workspace"
import SubscriptionHelper from "../../../../Helper/SubscriptionHelper"

const EditWorkspace = ({ afterAction }) => {
    const navigate = useNavigate();
    const { isAllowed } = SubscriptionHelper()
    const { getUser } = User()
    const [name, setName] = useState("")
    const [logo, setLogo] = useState(null)
    const [street, setStreet] = useState("")
    const [plz, setPlz] = useState("")
    const [city, setCity] = useState("")
    const [enablePreorder, setEnablePreorder] = useState(false)
    const [maxPreorders, setMaxPreorders] = useState(null)
    const [stripeKey, setStripeKey] = useState("")
    const [stripePublic, setStripePublic] = useState("")
    const [allowCardPayment, setAllowCardPayment] = useState(false)
    const [cashierUserTracking, setCashierUserTracking] = useState(false)
    const [cashRegisterStartMoney, setCashRegisterStartMoney] = useState(400)
    const [allowTwintPayment, setAllowTwintPayment] = useState(false)
    const [kitchenMonitor, setKitchenMonitor] = useState(false)
    const [lat, setLat] = useState(null)
    const [lon, setLon] = useState(null)
    const [orderDuration, setOrderDuration] = useState(null)
    const [openTime, setOpenTime] = useState(null)
    const [closeTime, setCloseTime] = useState(null)
    const [type, setType] = useState("NOT_DEFINED")
    const [currency, setCurrency] = useState("CHF")
    const [uuidNumber, setUuidNumber] = useState("")
    const [useTimeTracking, setUseTimeTracking] = useState(false)
    const { updateWorkspace, deleteWorkspace } = Workspace()
    const [workspace, setWorkspace] = useState(null)
    useEffect(() => {
        async function saveWorkspace() {
            const data = await getWorkspace()
            setWorkspace(data)
        }
        saveWorkspace()
    }, [])
    const subscription = workspace?.subscription;
    const isTester = workspace?.freeTester;

    const WORKSPACE_TYPES = [
        { value: "NOT_DEFINED", label: "Nicht definiert" },
        { value: "CAFFEE", label: "Café" },
        { value: "BAR", label: "Bar" },
        { value: "RESTAURANT", label: "Restaurant" },
        { value: "FOOD_TRUCK", label: "Food Truck" },
        { value: "FOOD_STAND", label: "Essensstand" }
    ]

    const CURRENCY_OPTIONS = [
        { value: "CHF", label: "CHF" },
        { value: "EUR", label: "EUR" },
        { value: "USD", label: "USD" },
        { value: "GBP", label: "GBP" }
    ]

    useEffect(() => {
        handleDataLoad()
    }, [])

    const handleDataLoad = async () => {
        const data = await getWorkspace()
        setName(data.name)
        setLogo(data.logo)
        setStreet(data.street)
        setPlz(data.plz)
        setCity(data.city)
        setEnablePreorder(data.enablePreorder)
        setMaxPreorders(data.maxPreorders)
        setStripeKey(data.stripeKey)
        setStripePublic(data.stripePublic)
        setAllowCardPayment(data.allowCardPayment)
        setAllowTwintPayment(data.allowTwintPayment)
        setKitchenMonitor(data.kitchenMonitor)
        setLon(data.longitude)
        setLat(data.latitude)
        setOrderDuration(data.orderDuration)
        setOpenTime(data.openTime)
        setCloseTime(data.closeTime)
        setType(data.type)
        if (data.currency) {
            setCurrency(data.currency)
        }
        setCashierUserTracking(data.cashierUserTracking)
        setCashRegisterStartMoney(data.cashRegisterStartMoney)
        setUuidNumber(data.uuidNumber)
        setUseTimeTracking(data.useTimeTracking)
    }

    const handleUpdateWorkspace = async () => {
        const workspaceDTO = {
            name: name,
            logo: logo,
            street: street,
            plz: plz,
            city: city,
            enablePreorder: enablePreorder,
            maxPreorders: maxPreorders,
            stripeKey: stripeKey,
            stripePublic: stripePublic,
            allowCardPayment: allowCardPayment,
            allowTwintPayment: allowTwintPayment,
            kitchenMonitor: kitchenMonitor,
            latitude: lat,
            longitude: lon,
            orderDuration: orderDuration,
            openTime: openTime,
            closeTime: closeTime,
            type: type,
            currency: currency,
            cashierUserTracking: cashierUserTracking,
            cashRegisterStartMoney: cashRegisterStartMoney,
            uuidNumber: uuidNumber,
            useTimeTracking: useTimeTracking
        }
        await updateWorkspace(workspaceDTO)
        await getUser()
        afterAction()
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleUpdateWorkspace()
    }

    const handleDelete = async (e) => {
        e.preventDefault();
        const confirmDelete = window.confirm("Bist du sicher, dass du diesen Workspace löschen möchtest?");
        if (!confirmDelete) return;

        const data = await deleteWorkspace();
        if (data.ok) {
            navigate("/app");
        }
    }

    const baseSettings = () => (
        <div className="flex flex-col gap-1">
            <Text type="maintitle" classNames={"w-full flex text-start mb-4"} >Allgemeine Einstellungen</Text>
            <TextInput attribute={name} id={"name"} label={"Workspace Name"} placeholder={"Workspace Name"} action={(e) => setName(e.target.value)} />
            <TextInput attribute={uuidNumber} id={"uuidNumber"} label={"UID-Nummer"} placeholder={"CHE-123.456.789 MWST"} action={(e) => setUuidNumber(e.target.value)} />
            <TextInput attribute={street} id={"street"} label={"Strasse"} placeholder={"Strasse Nr"} action={(e) => setStreet(e.target.value)} required={false} />
            <TextInput attribute={plz} id={"plz"} label={"Postleitzahl"} placeholder={"Postleitzahl"} action={(e) => setPlz(e.target.value)} required={false} />
            <TextInput attribute={city} id={"city"} label={"Stadt"} placeholder={"Stadt"} action={(e) => setCity(e.target.value)} required={false} />
            <GoogleMapsLocation
                street={street}
                postalCode={plz}
                city={city}
                onCoordinates={({ lat, lon }) => {
                    setLat(lat)
                    setLon(lon)
                }}
            />
            <Dropdown
                options={WORKSPACE_TYPES}
                value={type}
                onChange={setType}
                label="Workspace Typ:"
            />
            <Dropdown
                options={CURRENCY_OPTIONS}
                value={currency}
                onChange={setCurrency}
                label="Währung:"
            />
            <FileUploader
                attribute={logo}
                id={"logo"}
                label={"Firmenlogo"}
                onFileLoad={(blobString, file) => {
                    setLogo(blobString)
                }}
            />
            <Checkbox
                attribute={kitchenMonitor}
                id="kitchenMonitor"
                label="Küchenmonitor aktivieren"
                required={false}
                action={(e) => setKitchenMonitor(e.target.checked)}
            />
            {isAllowed("allowTimeTracking") && (
                <Checkbox
                    attribute={useTimeTracking}
                    id="useTimeTracking"
                    label="Time Tracking erlauben"
                    required={false}
                    action={(e) => setUseTimeTracking(e.target.checked)}
                />
            )}

        </div>
    )

    const preorderSettings = () => (
        <div className="flex flex-col">
            <Text type="maintitle" classNames={"w-full flex text-start mb-4"} >Vorbestellungs Einstellungen</Text>
            <Checkbox
                attribute={enablePreorder}
                id="enablePreorder"
                label="Vorbestellungen zulassen"
                required={false}
                action={(e) => setEnablePreorder(e.target.checked)}
            />
            <TextInput attribute={openTime} id={"openTime"} label={"Öffnungszeit"} type="time" action={(e) => setOpenTime(e.target.value)} required={false} />
            <TextInput attribute={closeTime} id={"closeTime"} label={"Schliessungszeit"} type="time" action={(e) => setCloseTime(e.target.value)} required={false} />
            <NumberInput
                attribute={orderDuration}
                id={"orderDuration"}
                label={"Min Dauer bis Bestellung fertig ist (in Minuten)"}
                required={false}
                action={(e) => setOrderDuration(e.target.value)}
            />
            <NumberInput
                attribute={maxPreorders}
                id={"maxPreorders"}
                label={"Maximal gleichzeitige Vorbestellungen (leer ist unbegrenzt)"}
                required={false}
                action={(e) => setMaxPreorders(e.target.value)}
            />
        </div>
    )

    const cashRegisterSettings = () => (
        <div className="flex flex-col">
            <Text type="maintitle" classNames={"w-full flex text-start mb-4"} >Kasseneinstellungen</Text>
            {(isTester || (subscription && subscription["useCard"])) && (<>
                <Checkbox
                    attribute={allowCardPayment}
                    id="allowCardPayment"
                    label="Kartenzahlung zulassen"
                    required={false}
                    action={(e) => setAllowCardPayment(e.target.checked)}
                />
                {(isTester || (subscription && subscription["useCard"])) && (
                    <SumUpPayment />
                )}
            </>)}
            {(isTester || (subscription && subscription["allowCashierUserTracking"])) && (<>
                <Checkbox
                    attribute={cashierUserTracking}
                    id="cashierUserTracking"
                    label="Kassenabrechnung und Kassenpin"
                    required={false}
                    action={(e) => setCashierUserTracking(e.target.checked)}
                />
                <NumberInput
                    attribute={cashRegisterStartMoney}
                    id={"cashRegisterStartMoney"}
                    label={"Geldbetrag bei einer neuen Kasse"}
                    required={false}
                    action={(e) => setCashRegisterStartMoney(e.target.value)}
                />
            </>)}
        </div>
    )

    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={"Workspace updaten"} size="w-full">
            <div className="h-full flex flex-col gap-4 divide-y">
                <Text type="maintitle" classNames={"w-full flex text-start"} >Workspace Aktualisieren</Text>
                {baseSettings()}
                {cashRegisterSettings()}
                {/* {preorderSettings()} */}
                <div className="w-full px-5 py-2">
                    <Button text={"Workspace Löschen"} buttonColor="bg-red-500" classNames="w-full" onClickAction={(e) => handleDelete(e)} />
                </div>
            </div>

        </Form>
    )
}

export default EditWorkspace